var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attention__block flex__ec",class:{'active': _vm.active, 'pointer': _vm.click},on:{"click":() => { _vm.click && _vm.click() }}},[_c('IconAttention',{staticClass:"mr__20"}),_c('div',{staticClass:"attention__block__text"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }